import React from "react";
import Container from "./Container";

/**
 * Editorial section wrapper.
 * tone: "default" | "warm" | "azure" | "none"
 */
const tones = {
  default: "bg-paper dark:bg-night",
  warm: "bg-paper-warm dark:bg-night-surface",
  azure: "bg-gradient-brand text-paper",
  none: "",
};

const Section = ({
  id,
  tone = "default",
  className = "",
  innerClassName = "",
  bleed = false,
  children,
}) => (
  <section
    id={id}
    className={`relative py-20 md:py-28 lg:py-36 ${tones[tone] || ""} ${className}`}
  >
    {bleed ? children : (
      <Container className={innerClassName}>{children}</Container>
    )}
  </section>
);

export default Section;
